import React, { useState } from "react";

import s from "./ui.module.scss";

export interface TabItem {
  key: string;
  label: React.ReactNode;
  content: React.ReactNode;
}

interface TabsProps {
  items: TabItem[];
  defaultActiveKey?: string;
  /** Controlled active key. When provided, Tabs is controlled and `onChange` drives changes. */
  activeKey?: string;
  /** Called with the next key when a tab is clicked (use with `activeKey` for URL-synced tabs). */
  onChange?: (key: string) => void;
  className?: string;
}

const Tabs = ({ items, defaultActiveKey, activeKey, onChange, className }: TabsProps) => {
  const [internal, setInternal] = useState(defaultActiveKey || items[0]?.key);
  const controlled = activeKey !== undefined;
  const active = controlled ? activeKey : internal;
  const activeItem = items.find((i) => i.key === active) || items[0];

  const select = (key: string) => {
    if (!controlled) setInternal(key);
    onChange?.(key);
  };

  return (
    <div className={className}>
      <div className={s.tabsBar} role="tablist">
        {items.map((it) => (
          <button
            key={it.key}
            type="button"
            role="tab"
            aria-selected={it.key === active}
            className={`${s.tabBtn}${it.key === active ? ` ${s.tabBtnActive}` : ""}`}
            onClick={() => select(it.key)}
          >
            {it.label}
          </button>
        ))}
      </div>
      <div className={s.tabPanel} role="tabpanel">
        {activeItem?.content}
      </div>
    </div>
  );
};

export default Tabs;
